import React from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/react';
import { ProgramCategory } from '@gql/generated';

const List = styled.div`
  max-height: 100vh;
  position: sticky;
  top: 50px;
  border-left: 1px solid ${({ theme }) => theme.colors.neutrals['light-gray']};

  overflow-x: hidden;
  overflow-y: scroll;
`;

const Title = styled.p`
  height: 59px;
  color: rgb(36, 36, 36);
  font-size: 15px;
  font-weight: 600;
  line-height: 19px;
  border-top: 1px solid #f1f1f1;
  border-bottom: 1px solid #f1f1f1;
  padding: 20px;
  margin: 0;
`;

const BottomIndicator = styled.div`
  position: sticky;
  bottom: 1px;
  height: 80px;
  width: 100%;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.4) 30%,
    #fff 100%
  );
  z-index: 5;
`;

type ProgramTypes = Partial<Record<ProgramCategory, React.ReactNode>>;
const programTypes: ProgramTypes = {
  [ProgramCategory['Programs']]: (
    <Trans id="weeklyProgram.weekly_progress.program_content" />
  ),
  [ProgramCategory['Courses']]: (
    <Trans
      id="courses_2021.progress_page.parts_title"
      message="Course content"
    />
  ),
};

type Props = {
  children: React.ReactNode;
  programCategory?: ProgramCategory;
};
const CollapsableVideoList = (props: Props) => {
  const { children, programCategory } = props;

  const title = programTypes[programCategory || ProgramCategory['Programs']];

  return (
    <List id="program-steps">
      <Title>{title}</Title>
      {children}
      <BottomIndicator />
    </List>
  );
};

export default CollapsableVideoList;
